import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './HeaderRow.css';

export interface IHeaderRowProps {
  position: number;
  sticky?: boolean;
}

const HeaderRow = React.forwardRef<HTMLDivElement, React.PropsWithChildren<IHeaderRowProps>>((props, ref) => {
  const { children, sticky } = props;

  return (
    <div ref={ref} className={clsx(style['row'], sticky && style['row--sticky'])}>
      {children}
    </div>
  );
});

HeaderRow.displayName = 'HeaderRow';

export { HeaderRow };
